import apiClient from "../auth/apiClient";

class DeviceControlService {
    constructor(client) {
        this.apiClient = client;
    }

    async GetSidePanelData(_entityID, userID, isAdmin) {
        const endpoint = `devicecontrol/entities/${_entityID}`;
        const queryParams = new URLSearchParams({
            userID: userID,
            isAdmin: String(isAdmin)
        });

        return await this.apiClient.get(`${endpoint}?${queryParams}`);
    }

}

export default DeviceControlService;
